module.exports = __webpack_public_path__ + "static/img/changeMap.eebf797.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/boss-underStudent/changeMap.png
// module id = 5bEr
// module chunks = 1